import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=587d7947&scoped=true&lang=pug"
import script from "./MessageList.vue?vue&type=script&lang=ts"
export * from "./MessageList.vue?vue&type=script&lang=ts"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=587d7947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d7947",
  null
  
)

export default component.exports